module.exports = __webpack_public_path__ + "img/img_023@2x.19be5e5f.png";